import _ from 'lodash'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const mapFieldMenuFilter = (item) => {
  return {
    id: item?.menu_id,
    name: item?.menu_name,
    description: item?.menu_description,
  }
}

export const getMenuFilterListApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/menu',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldMenuFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
